module.exports = __webpack_public_path__ + "../resources/img/ic_in_progress_number_1.a02585c8.svg";